export default __webpack_public_path__ + "fe687731855298b4807ee4a49c3bf27c.png";